import type { File, FileType, PotentiallyUnhydratedFile } from '@/types/File'
import type { Tag } from '@/types/Tag'

const ORGANIZATION_FILE_DEFAULT_LABEL = 'Library File'
const PURSUIT_FILE_DEFAULT_LABEL = 'Pursuit File'
const WORD_TEMPLATE_FILE_DEFAULT_LABEL = 'Word Template'
const USER_FILE_DEFAULT_LABEL = 'My File'

const DEFAULT_LABEL_MAP: Record<FileType, string> = {
  organization_file: ORGANIZATION_FILE_DEFAULT_LABEL,
  pursuit_file: PURSUIT_FILE_DEFAULT_LABEL,
  dibbs_contract_file: PURSUIT_FILE_DEFAULT_LABEL,
  sled_contract_file: PURSUIT_FILE_DEFAULT_LABEL,
  federal_contract_file: PURSUIT_FILE_DEFAULT_LABEL,
  federal_grant_file: PURSUIT_FILE_DEFAULT_LABEL,
  sbir_file: PURSUIT_FILE_DEFAULT_LABEL,
  word_template_file: WORD_TEMPLATE_FILE_DEFAULT_LABEL,
  user_file: USER_FILE_DEFAULT_LABEL,
  agent_session_file: 'Chat File',
}

export const getKnowledgeBaseLabel = (
  file: PotentiallyUnhydratedFile,
  orgTags: Tag[],
  defaultLabelMap: Record<FileType, string> = DEFAULT_LABEL_MAP,
  useLegacyFolderNames: boolean = true,
) => {
  switch (file.type) {
    case 'organization_file':
      return (
        orgTags?.find((tag) => file.organization_file?.tag_ids.includes(tag.id))
          ?.name ?? defaultLabelMap.organization_file
      )
    case 'pursuit_file':
      return defaultLabelMap.pursuit_file
    case 'dibbs_contract_file':
      return defaultLabelMap.dibbs_contract_file
    case 'federal_contract_file':
      return defaultLabelMap.federal_contract_file
    case 'federal_grant_file':
      return defaultLabelMap.federal_grant_file
    case 'sbir_file':
      return defaultLabelMap.sbir_file
    case 'sled_contract_file':
      return defaultLabelMap.sled_contract_file
    case 'word_template_file':
      return defaultLabelMap.word_template_file
    case 'user_file':
      return defaultLabelMap.user_file
    case 'agent_session_file':
      return defaultLabelMap.agent_session_file
    default: {
      // this exhaustiveness check ensures we handle all possible file types
      const exhaustiveCheck: never = file.type
      return defaultLabelMap.organization_file
    }
  }
}

export const getKnowledgeBaseLabels = (
  files: PotentiallyUnhydratedFile[],
  orgTags: Tag[],
  defaultLabelMap: Record<FileType, string> = DEFAULT_LABEL_MAP,
) => {
  const labels = new Set<string>()
  for (const file of files) {
    labels.add(getKnowledgeBaseLabel(file, orgTags, defaultLabelMap))
  }
  return Array.from(labels)
}
